import { render, staticRenderFns } from "./TDProductionDialogTable.vue?vue&type=template&id=0f0fea42"
import script from "./TDProductionDialogTable.vue?vue&type=script&lang=js"
export * from "./TDProductionDialogTable.vue?vue&type=script&lang=js"
import style0 from "./TDProductionDialogTable.vue?vue&type=style&index=0&id=0f0fea42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports